function AppleIcon() {
  return (
    <svg
      aria-hidden="true"
      aria-label=""
      className="default__Uvi icon__gUZ iconBlock__U9O block__kVc"
      height="20"
      role="img"
      viewBox="0 0 24 24"
      width="20"
    >
      <path d="M21.3 18.7q-.55 1.26-1.3 2.32-1.02 1.45-1.66 2.01-1 .91-2.14.94-.81 0-1.97-.47a6 6 0 0 0-2.12-.47q-1.02 0-2.19.47-1.16.48-1.89.5-1.09.04-2.18-.97-.69-.6-1.74-2.08a14 14 0 0 1-1.84-3.65q-.77-2.25-.77-4.35 0-2.42 1.04-4.16a6.1 6.1 0 0 1 5.14-3.04q.87 0 2.29.53 1.41.53 1.81.53.3 0 2.01-.63a7 7 0 0 1 2.74-.48q3.03.24 4.54 2.39a5.1 5.1 0 0 0-2.68 4.6q.03 2.29 1.66 3.81.75.7 1.67 1.1-.2.57-.43 1.1M16.65.48q0 1.8-1.31 3.36c-1.06 1.23-2.33 1.94-3.72 1.83l-.02-.45c0-1.16.5-2.39 1.39-3.4A5 5 0 0 1 14.7.55 5 5 0 0 1 16.64 0z" />
    </svg>
  );
}

export default AppleIcon;
